module.exports = __webpack_public_path__ + "static/media/nurseBg.acfaea83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nurseBg.jpg
// module id = 487
// module chunks = 0